export default {
    GENERIC:{
        code: 'error.generic_error',
        message: '',
    },
    UNAUTHORIZED:{
        code: 'error.unauthorized',
        message: '',
    },
    NOTFOUND:{
        code: 'error.not_found',
        message: '',
    },
    CANNOT_UPDATE_DB:{
        code: 'error.db_update_error',
        message: '',
    },
    BAD_REQUEST:{
        code: 'error.bad_request',
        message: '',
    },
    CONFLICT:{
        code: 'error.conflict',
        message: '',
    },
    UNKNOWN:{
        code: 'error.unknown',
        message: 'errore nell\'invio della richiesta',
    },
};